module.exports = __webpack_public_path__ + "img/mrs_figg.d8fa4dc8.jpg";